import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import html2pdf from 'html2pdf.js';
import axios from 'axios';
import { formatDocument, formatPhone } from '../../common/formatters';
import { httpClient } from '../../common/httpclient';


export const downloadServiceOrderPDF = async (osId, download = false) => {
    if (!osId) return;


    // Tenta baixar diretamente do endpoint PDF, se disponível
    try {
        // Faz a requisição para o endpoint /orderservices/{id}/pdf
        const pdfResponse = await httpClient.get(`/orderservices/${osId}/pdf`, {
            responseType: 'blob'
        });

        if (pdfResponse && pdfResponse.status === 200 && pdfResponse.data) {
            // Cria o Blob e faz o download automático
            const blob = pdfResponse.data instanceof Blob ? pdfResponse.data : new Blob([pdfResponse.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `OrdemServico_${osId}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            return; // Retorna para não executar o fluxo antigo
        }
    } catch (error) {
        // Se for 404, segue com o fluxo padrão antigo.
        if (error.response && error.response.status !== 404) {
            throw error; // Outros erros além de 404 sobem normalmente
        }
        // Caso 404, nada a fazer, segue fluxo padrão abaixo
    }

    const storage = localStorage;
    
    const response = await httpClient.get(`/orderservices/print/${osId}`);
    const data = response.data;

    if (!data) return;



    const countItems = data.order_items && data.order_items.length || 0;
    const fontSize = countItems >= 18 ? '60%' : countItems > 18 ? '40%' : '14px';

    const showInstagram = !!data.enterprise_instagram;
    const showFacebook = !!data.enterprise_facebook;
    const showTerms = !!data.order_terms;
    const showVehicle = (storage.getItem('vehicle') === 'true') && data.vehicle_manufacturer;
    const showDefectReason = !!(data.defect_reason && String(data.defect_reason).trim());
    const defectReasonEscaped = showDefectReason
        ? String(data.defect_reason).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        : '';
    const hasLogo = !!data.order_logo;
    const hasSignatureImage = !!data.signature_image;

    const imgSrc = `data:image/jpg;base64,${data.order_logo}`;
    const signatureImgSrc = hasSignatureImage ? `data:image/jpg;base64,${data.signature_image}` : null;

    ;
    

    const htmlItems = data.order_items && data.order_items.map(item => {
        const discType = item.item_discount_type;
        const discAmt = item.item_discount_amount;
        const discountHtml =
            discType && String(discType).trim()
                ? `<div class="item-discount">Desc. linha: ${discType}${
                      discAmt ? ` (− R$ ${discAmt})` : ''
                  }</div>`
                : '';
        return `
      <div class="item-row">
        <div class="item-quantity">${item.quantity}</div>
        <div class="item-description">${item.item_name}${discountHtml}</div>
        <div class="item-price">${item.amount_unit}</div>
        <div class="item-total">${item.amount_total}</div>
      </div>
    `;
    }).join('');

    const htmlString = `
      <style>
        * {
          box-sizing: border-box;
        }
        
        body {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          line-height: 1.4;
          color: #333;
          background: #fff;
          margin: 0;
          padding: 0;
        }
        
        .header-section {
          background: #f8f9fa;
          
          padding: 15px;
          margin-bottom: 15px;
          border-radius: 8px;
        }
        
        .enterprise-info {
          display: flex;
          align-items: center;
          gap: 15px;
        }
        
        .enterprise-logo {
          width: 60px;
          height: 60px;
          border-radius: 6px;
          object-fit: cover;
          flex-shrink: 0;
        }
        
        .enterprise-logo-fallback {
          width: 60px;
          height: 60px;
          background: #667eea;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          font-size: 20px;
          flex-shrink: 0;
        }
        
        .enterprise-details {
          flex: 1;
        }
        
        .enterprise-name {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 4px;
          color: #667eea;
        }
        
        .enterprise-banner {
          font-size: 14px;
          color: #666;
          margin-bottom: 3px;
        }
        
        .enterprise-document {
          font-size: 12px;
          color: #666;
        }
        
        .order-number {
          background: #667eea;
          color: white;
          padding: 10px 15px;
          border-radius: 6px;
          text-align: center;
          margin-bottom: 8px;
        }
        
        .order-number h2 {
          font-size: 18px;
          font-weight: 700;
          margin: 0;
        }
        
        .order-number .order-num {
          font-size: 14px;
          margin-top: 2px;
        }
        
        .contact-info {
          display: flex;
          flex-direction: column;
          gap: 3px;
          margin-top: 12px;
          text-align: right;
        }
        
        .contact-item {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 5px;
          font-size: 12px;
          color: #666;
        }
        
        .phone-row {
          display: flex;
          gap: 10px;
          justify-content: flex-end;
          margin-bottom: 3px;
          flex-wrap: nowrap;
        }
        
        .phone-item {
          display: flex;
          align-items: center;
          gap: 2px;
          font-size: 12px;
          color: #666;
          white-space: nowrap;
        }
        
        .contact-item img {
          width: 12px;
          height: 12px;
        }
        
        .social-links {
          display: flex;
          gap: 15px;
          margin-top: 5px;
          justify-content: flex-end;
          flex-wrap: nowrap;
        }
        
        .social-item {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 11px;
          color: #666;
          white-space: nowrap;
        }
        
        .social-item img {
          width: 14px;
          height: 14px;
        }
        
        .section-divider {
          height: 1px;
          background: #667eea;
          border: none;
          margin: 15px 0;
        }
        
        .info-section {
          background: #f8f9fa;
          padding: 12px;
          border-radius: 6px;
          margin-bottom: 12px;
          border-left: 3px solid #667eea;
        }
        
        .info-grid {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 10px;
        }
        
        .info-item {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }
        
        .info-label {
          font-weight: 600;
          color: #667eea;
          font-size: 10px;
          text-transform: uppercase;
          letter-spacing: 0.3px;
        }
        
        .info-value {
          font-size: 12px;
          color: #333;
        }
        
        .vehicle-section {
          background: #e8f4fd;
          padding: 12px;
          border-radius: 6px;
          margin-bottom: 12px;
          border-left: 3px solid #2196f3;
        }
        
        .vehicle-grid {
          display: grid;
          grid-template-columns: 2fr 1fr 2fr 1fr;
          gap: 8px;
        }
        
        .items-section {
          background: white;
          border: 1px solid #e0e0e0;
          border-radius: 6px;
          overflow: hidden;
          margin-bottom: 15px;
        }
        
        .items-header {
          background: #667eea;
          color: white;
          padding: 8px 12px;
          font-weight: 600;
          display: grid;
          grid-template-columns: 50px 1fr 80px 70px;
          gap: 8px;
          align-items: center;
          font-size: 12px;
        }
        
        .items-body {
          padding: 0;
        }
        
        .item-row {
          display: grid;
          grid-template-columns: 50px 1fr 80px 70px;
          gap: 8px;
          align-items: center;
          padding: 8px 12px;
          border-bottom: 1px solid #f0f0f0;
          font-size: 11px;
        }
        
        .item-row:last-child {
          border-bottom: none;
        }
        
        .item-quantity {
          font-weight: 600;
          color: #667eea;
          text-align: center;
        }
        
        .item-description {
          color: #333;
          font-weight: 500;
        }
        
        .item-discount {
          font-size: 9px;
          color: #c62828;
          font-weight: 500;
          margin-top: 2px;
        }
        
        .item-price {
          text-align: right;
          font-weight: 600;
          color: #333;
        }
        
        .item-total {
          text-align: right;
          font-weight: 700;
          color: #2e7d32;
        }
        
        .totals-section {
          background: #f8f9fa;
          padding: 12px;
          border-radius: 6px;
          margin-bottom: 15px;
        }
        
        .totals-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px;
        }
        
        .terms-section {
          background: #fff3e0;
          padding: 10px;
          border-radius: 6px;
          border-left: 3px solid #ff9800;
        }
        
        .terms-title {
          font-weight: 700;
          color: #e65100;
          margin-bottom: 8px;
          font-size: 12px;
        }
        
        .terms-content {
          font-size: 10px;
          line-height: 1.4;
          color: #333;
          text-align: justify;
        }
        
        .totals-right {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }
        
        .total-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 4px 0;
          font-size: 12px;
        }
        
        .total-label {
          font-weight: 600;
          color: #666;
        }
        
        .total-value {
          font-weight: 700;
          color: #333;
        }
        
        .total-final {
          border-top: 2px solid #667eea;
          padding-top: 6px;
          margin-top: 4px;
        }
        
        .total-final .total-label {
          font-size: 14px;
          color: #667eea;
        }
        
        .total-final .total-value {
          font-size: 16px;
          color: #667eea;
        }
        
        .signature-section {
          text-align: center;
          margin-top: 20px;
          padding: 15px;
        }
        
        .signature-image {
          max-width: 300px;
          max-height: 100px;
          margin: 0 auto 8px;
          display: block;
          object-fit: contain;
        }
        
        .signature-line {
          border-bottom: 2px solid #333;
          width: 250px;
          margin: 0 auto 8px;
          height: 30px;
        }
        
        .signature-name {
          font-weight: 600;
          color: #333;
          font-size: 14px;
        }
        
        /* Responsive Design */
        @media (max-width: 768px) {
          .header-section {
            padding: 12px;
          }
          
          .enterprise-info {
            gap: 10px;
          }
          
          .enterprise-logo {
            width: 50px;
            height: 50px;
          }
          
          .enterprise-logo-fallback {
            width: 50px;
            height: 50px;
            font-size: 18px;
          }
          
          .enterprise-name {
            font-size: 18px;
          }
          
          .order-number h2 {
            font-size: 16px;
          }
          
          .info-grid {
            grid-template-columns: 1fr 1fr;
            gap: 8px;
          }
          
          .vehicle-grid {
            grid-template-columns: 1fr 1fr;
            gap: 6px;
          }
          
          .items-header,
          .item-row {
            grid-template-columns: 40px 1fr 70px 60px;
            gap: 6px;
            padding: 6px 8px;
            font-size: 10px;
          }
          
          .totals-grid {
            grid-template-columns: 1fr;
            gap: 10px;
          }
        }
        
        @media (max-width: 480px) {
          .header-section {
            padding: 10px;
          }
          
          .enterprise-info {
            gap: 8px;
          }
          
          .enterprise-logo {
            width: 40px;
            height: 40px;
          }
          
          .enterprise-logo-fallback {
            width: 40px;
            height: 40px;
            font-size: 16px;
          }
          
          .enterprise-name {
            font-size: 16px;
          }
          
          .order-number h2 {
            font-size: 14px;
          }
          
          .info-grid {
            grid-template-columns: 1fr;
            gap: 6px;
          }
          
          .items-header,
          .item-row {
            grid-template-columns: 35px 1fr 60px 50px;
            gap: 4px;
            padding: 4px 6px;
            font-size: 9px;
          }
          
          .signature-line {
            width: 180px;
          }
          
          .signature-image {
            max-width: 200px;
            max-height: 80px;
          }
        }
        
        @media print {
          body { 
            -webkit-print-color-adjust: exact; 
            print-color-adjust: exact;
            font-size: 11px;
            line-height: 1.3;
          }
          
          .header-section { 
            break-inside: avoid; 
            margin-bottom: 10px;
            padding: 10px;
          }
          
          .info-section,
          .vehicle-section {
            break-inside: avoid;
            margin-bottom: 8px;
            padding: 8px;
          }
          
          .items-section { 
            break-inside: avoid; 
            margin-bottom: 10px;
          }
          
          .items-header {
            padding: 6px 8px;
            font-size: 10px;
          }
          
          .item-row {
            padding: 4px 8px;
            font-size: 9px;
          }
          
          .totals-section {
            break-inside: avoid;
            margin-bottom: 10px;
            padding: 8px;
          }
          
          .signature-section {
            margin-top: 15px;
            padding: 10px;
          }
          
          .signature-image {
            max-width: 250px;
            max-height: 80px;
          }
          
          .signature-line {
            width: 200px;
            height: 25px;
          }
          
          .signature-name {
            font-size: 12px;
          }
        }
      </style>
      <html>
        <head>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.css">
          <title>ORDEM DE SERVIÇO</title>
        </head>
        <body>
          <div class="container-fluid">
            <!-- Header Section -->
            <div class="header-section">
              <div class="row align-items-center">
                <div class="col-md-8">
                  <div class="enterprise-info">
                    ${hasLogo ? 
                      `<img class="enterprise-logo" src="${imgSrc}" alt="Logo da empresa" style="width:60px; height:60px; border-radius:6px; object-fit:cover; flex-shrink:0;">
                       <div class="enterprise-logo-fallback" style="display:none; width:60px; height:60px; background:#667eea; border-radius:6px; align-items:center; justify-content:center; color:white; font-weight:bold; font-size:20px;">${data.enterprise_name ? data.enterprise_name.charAt(0).toUpperCase() : 'L'}</div>` :
                      `<div class="enterprise-logo-fallback" style="width:60px; height:60px; background:#667eea; border-radius:6px; display:flex; align-items:center; justify-content:center; color:white; font-weight:bold; font-size:20px;">${data.enterprise_name ? data.enterprise_name.charAt(0).toUpperCase() : 'L'}</div>`
                    }
                    <div class="enterprise-details">
                      <div class="enterprise-name">${data.enterprise_name}</div>
                      <div class="enterprise-banner">${data.order_banner || ''}</div>
                      <div class="enterprise-document">${data.enterprise_document}</div>
                     
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="order-number">
                    <h2>ORDEM DE SERVIÇO</h2>
                    <div class="order-num">N.º ${data.number}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-8">
                </div>
                <div class="col-md-4">
                  <div class="contact-info">
                   <div style="margin-top: 8px; font-size: 12px; color: #666;">
                        <span style="margin-right:4px;vertical-align:middle; font-size:14px;">📍</span>
                        <span>${data.enterprise_address}, ${data.enterprise_number_address}, ${data.enterprise_neighborhood}, ${data.enterprise_city}/${data.enterprise_state}</span>
                      </div>
                    <div class="phone-row">
                      <div class="phone-item">
                        <span style="margin-right:4px;vertical-align:middle; font-size:14px;">📱</span>
                        <span>${formatPhone(data.enterprise_cellphone)}</span>
                      </div>
                      <div class="phone-item">
                        <span style="margin-right:4px;vertical-align:middle; font-size:14px;">📞</span>
                        <span>${formatPhone(data.enterprise_phone_number)}</span>
                      </div>
                    </div>
                    <div class="social-links">
                      ${showFacebook ? `
                        <div class="social-item">
                          <span style="margin-right:4px;vertical-align:middle; font-size:14px;">📘</span>
                          <span>${data.enterprise_facebook}</span>
                        </div>
                      ` : ''}
                      ${showInstagram ? `
                        <div class="social-item">
                          <span style="margin-right:4px;vertical-align:middle; font-size:14px;">📷</span>
                          <span>${data.enterprise_instagram}</span>
                        </div>
                      ` : ''}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <hr class="section-divider">
            
            <!-- Customer Information Section -->
            <div class="info-section">
              <div class="info-grid">
                <div class="info-item">
                  <div class="info-label">Data Entrada</div>
                  <div class="info-value">${data.order_date}</div>
                </div>
                <div class="info-item">
                  <div class="info-label">Data Saída</div>
                  <div class="info-value">${data.order_delivery_date}</div>
                </div>
                <div class="info-item">
                  <div class="info-label">Cliente</div>
                  <div class="info-value">${data.customer_name}</div>
                </div>
                <div class="info-item">
                  <div class="info-label">CPF/CNPJ</div>
                  <div class="info-value">${formatDocument(data.customer_document)}</div>
                </div>
                <div class="info-item">
                  <div class="info-label">Endereço</div>
                  <div class="info-value">${data.customer_address || 'Não informado'}</div>
                </div>
                <div class="info-item">
                  <div class="info-label">Contato</div>
                  <div class="info-value">${formatPhone(data.customer_cellphone)}</div>
                </div>
              </div>
            </div>
            
            ${showVehicle ? `
              <!-- Vehicle Information Section -->
              <div class="vehicle-section">
                <div class="vehicle-grid">
                  <div class="info-item">
                    <div class="info-label">Veículo</div>
                    <div class="info-value">${data.vehicle_manufacturer} ${data.vehicle_model}</div>
                  </div>
                  <div class="info-item">
                    <div class="info-label">Placa</div>
                    <div class="info-value">${data.vehicle_license_plate}</div>
                </div>
                  <div class="info-item">
                    <div class="info-label">Chassi</div>
                    <div class="info-value">${data.vehicle_chassi || 'Não informado'}</div>
                </div>
                  <div class="info-item">
                    <div class="info-label">Quilometragem</div>
                    <div class="info-value">${data.vehicle_km} km</div>
                </div>
                </div>
            </div>
            ` : ''}

            ${showDefectReason ? `
              <!-- Defect Reason Section -->
              <div class="terms-section" style="margin-bottom: 10px;">
                <div class="terms-title">MOTIVO/DEFEITO:</div>
                <div class="terms-content">${defectReasonEscaped}</div>
              </div>
            ` : ''}

            <!-- Items Section -->
            <div class="items-section">
              <div class="items-header">
                <div>QTD</div>
                <div>DESCRIÇÃO</div>
                <div>VALOR UNID.</div>
                <div>TOTAL R$</div>
                </div>
              <div class="items-body">
                ${htmlItems || ''}
              </div>
            </div>
            <!-- Totals and Terms Section -->
            <div class="totals-section">
              <div class="totals-grid">
                ${showTerms ? `
                  <div class="terms-section">
                    <div class="terms-title">LEIA COM ATENÇÃO OS TERMOS E CONDIÇÕES:</div>
                    <div class="terms-content">
                    ${data.order_terms || ''}
                  </div>
                </div>
                ` : '<div></div>'}
                
                <div class="totals-right">
                  <div class="total-item">
                    <span class="total-label">Total Serviços:</span>
                    <span class="total-value">R$ ${data.order_amount_service}</span>
                  </div>
                  <div class="total-item">
                    <span class="total-label">Total Peças:</span>
                    <span class="total-value">R$ ${data.order_amount_product}</span>
                  </div>
                  ${
                    data.total_product_item_discount && String(data.total_product_item_discount).trim() && data.total_product_item_discount !== '0,00'
                        ? `<div class="total-item">
                    <span class="total-label">Desconto produto:</span>
                    <span class="total-value" style="color:#c62828">− R$ ${data.total_product_item_discount}</span>
                  </div>`
                        : ''
                  }
                  <div class="total-item total-final">
                    <span class="total-label">TOTAL GERAL:</span>
                    <span class="total-value">R$ ${data.order_amount}</span>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Signature Section -->
            <div class="signature-section">
              ${hasSignatureImage ? 
                `<img class="signature-image" src="${signatureImgSrc}" alt="Assinatura" />` :
                `<div class="signature-line"></div>`
              }
              <div class="signature-name">${data.customer_name}</div>
              <div style="font-size: 14px; color: #666; margin-top: 5px;">Cliente</div>
            </div>
          </div>
        </body>
      </html>
    `;

    const options = {
        filename: `ordem_servico_${data.number}.pdf`,
        image: { type: 'png', quality: 1 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4' }
    };

    if (download) {
        html2pdf()
            .set(options)
            .from(htmlString)
            .toPdf()
            .get('pdf')
            .save();
    } else {
        html2pdf()
            .set(options)
            .from(htmlString)
            .toPdf()
            .get('pdf')
            .then(function (pdf) {
                const pdfUrl = URL.createObjectURL(pdf.output('blob'));
                window.open(pdfUrl);
            });
    }
};

export default function Printer() {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);

    useEffect(() => {
        fetchData();
    }, [id]);

    const fetchData = async () => {
        try {

            setData({
                number: 'OS-001',
                customer_name: 'João Silva',
                customer_document: '123.456.789-00',
                customer_phone: '(11) 98765-4321',
                order_date: '01/01/2024',
                delivery_date: '05/01/2024',
                order_amount: '1.500,00',
                order_items: [
                    {
                        quantity: 1,
                        item_name: 'Manutenção de Notebook',
                        amount_unit: 'R$ 500,00',
                        amount_total: 'R$ 500,00'
                    },
                    {
                        quantity: 2,
                        item_name: 'Troca de Tela',
                        amount_unit: 'R$ 500,00',
                        amount_total: 'R$ 1.000,00'
                    }
                ],
                enterprise_name: 'Tech Solutions',
                enterprise_document: '12.345.678/0001-90',
                enterprise_phone: '(11) 3333-4444',
                enterprise_address: 'Rua das Flores, 123',
                enterprise_instagram: '@techsolutions',
                enterprise_facebook: 'Tech Solutions Oficial',
                order_terms: 'Garantia de 90 dias para serviços realizados'
            });
            setLoading(false);
        } catch (error) {

            setLoading(false);
        }
    };

    if (loading) {
        return <div>Carregando...</div>;
    }

    return (
        <div className="container mt-4">
            <div className="row">
                <div className="col-12">
                    <div className="d-flex justify-content-end gap-2">
                        <button
                            className="btn btn-primary"
                            onClick={() => downloadServiceOrderPDF(data, false)}
                        >
                            Visualizar PDF
                        </button>
                        <button
                            className="btn btn-success"
                            onClick={() => downloadServiceOrderPDF(data, true)}
                        >
                            Baixar PDF
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}